import styled from 'styled-components';

import { Form } from '@unform/web';

export const Wrapper = styled.div`
  margin: 10px;
`;

export const Header = styled.div`
  margin: 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
`;

export const Title = styled.h4`
  margin-bottom: 10px;
  font-weight: bold;
  color: #3d3d3d !important;
`;

export const Container = styled.div``;

export const InputArea = styled.div`
  display: grid;
  gap: 16px 10px;
  grid-template:
    'discount minimum_price'
    'coupon_name operation'
    'coupon_code maximum_discount'
    'date hourRange'
    'limitCoupon limitClientCouponUse';

  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
`;

export const StyledForm = styled(Form)``;

export const HourRange = styled.div`
  grid-area: 'hourRange';
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xxs};

  & > label {
    color: ${({ theme }) => theme.colors.neutral.dark};
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 150% */
    letter-spacing: 0.15px;
  }

  .selects_container {
    display: flex;
    gap: ${({ theme }) => theme.spacing.xs};
    align-items: center;

    color: ${({ theme }) => theme.colors.neutral.dark};
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 150% */
    letter-spacing: 0.15px;
  }
`;
